export class CustodianReportDTO{
    projectId:number;
    reportType:string;
    startDate:Date;
    endDate:Date;
}